import {Card} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {numberWithCommas} from '../../utils/helper'

const Reports = ({reports}) => {
return (
    <div className="row">
        <Card className="col-md-12 col-lg-4">
            <Card.Header
                as="h6"
                className="bg-white font-weight-bold"
            >
                At a Glance
            </Card.Header>
            <Card.Body>
                <div className="d-flex flex-row align-items-center">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                <FontAwesomeIcon
                                        icon={["fas", "thumbtack"]}
                                        className="mr-2 text-secondary"
                                        transform={{ rotate: 42 }}
                                    />
                                </td>
                                <td className="pr-2" align="right">
                                {numberWithCommas(reports.posts)}
                                </td>
                                <td>
                                Post{reports.posts > 1 ? 's': ''}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                <FontAwesomeIcon
                                    icon={["fas", "user"]}
                                    className="mr-2 text-secondary"
                                />
                                </td>
                                <td className="pr-2" align="right">{numberWithCommas(reports.users)}</td>
                                <td>Users</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="pr-2" align="right">{numberWithCommas(reports.subscribers)}</td>
                                <td>Subscribers</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="pr-2" align="right">{numberWithCommas(reports.creators)}</td>
                                <td>Creators</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    </div>
  )
}

export default Reports;